import * as Sentry from '@sentry/browser'
import axios from 'axios'
import { random } from 'lodash-es'

export const HTTP = axios.create({
  baseURL: '/api'
})

function processApiResponse (res) {
  if (res.data && res.data.success === true) {
    return res.data.data
  } else {
    const e = new Error('Server returned invalid response')

    Sentry.withScope(scope => {
      scope.setExtra('res_data', res.data)
      Sentry.captureException(e)
    })

    throw e
  }
}

export const UNSAFE_API_GET = (uri, q) => HTTP.get(uri, { params: {
  _: Date.now(),
  ...q
} }).then(processApiResponse)

export const API_GET = (uri, q) => UNSAFE_API_GET(uri, q).catch(e => {
  if (e.response && e.response.status === 401) {
    if (!uri.startsWith('/client')) {
      window.location.href = '/login'
    }
  }

  throw e
})

export const API_POST = (uri, q) => HTTP.post(uri, q).then(processApiResponse).catch(e => {
  if (e.response && e.response.status === 401) {
    window.location.href = '/login'
  }

  throw e
})

export const API_UPLOAD = (uri, data, mimeType) => axios.put(uri, data, {
  headers: {
    'Content-Type': mimeType
  }
})

async function wait (time) {
  return new Promise((resolve, reject) => {
    setTimeout(resolve, time)
  })
}

export const SAFE_API_GET = async (uri, q) => {
  try {
    const data = await API_GET(uri, q)

    return data
  } catch (e) {
    if (e.response && [ 404, 429 ].includes(e.response.status)) {
      await wait(random(800, 1200))
      return SAFE_API_GET(uri, q)
    } else throw e
  }
}
